import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteIncidentResponseStatus, getAllIncidentResponseStatuses,createIncidentResponseStatus,editIncidentResponseStatus } from '../../api/axiosIncidentResponseStatuses';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';




const IncidentResponseStatuses = () => {
  const { incidentResponseStatuses, setIncidentResponseStatuses, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [incidentResponseStatus, setIncidentResponseStatus] = useState("");
  const [editedIncidentResponseStatus, setEditedIncidentResponseStatus] = useState("");
  



 

  const NewTitle = "All IncidentResponseStatuses";
  useEffect(() => {
    
    getAllIncidentResponseStatuses(setIncidentResponseStatuses, setFetcherror);
    
  }, []);


  const filteredIncidentResponseStatuses = incidentResponseStatuses.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()));
  const filteredReversedIncidentResponseStatuses = filteredIncidentResponseStatuses.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setIncidentResponseStatuses, setFetcherror, handleAllToasts) => {
    return () => {
      deleteIncidentResponseStatus(pkid, setIncidentResponseStatuses, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this IncidentResponseStatus?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedIncidentResponseStatus(foundItem?.name);
   
   }

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
          <SearchToolBar
              setAddItemDialogVisible={setAddItemDialogVisible}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              searchPlaceholder="Response Status"
              createLabel="Response Status"
            />
            
        <DataTable
          value={filteredIncidentResponseStatuses}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No incident response status found"
        >
                    <Column header="S/N" body={(rowData) => incidentResponseStatuses.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Name"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                          <TableActions
                            id={rowData.id}
                            data={incidentResponseStatuses}
                            getItemtoEdit={getItemtoEdit}
                            setSelectedId={setSelectedId}
                            setEditDialogVisible={setEditDialogVisible}
                            setDeleteDialogVisible={ setDeleteDialogVisible}
                          />
                        
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New IncidentResponseStatus" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createIncidentResponseStatus(incidentResponseStatus, setIncidentResponseStatus, setFetcherror, handleAllToasts, setIncidentResponseStatuses);
                if (incidentResponseStatus) { setAddItemDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter IncidentResponseStatus Name"
                    value={incidentResponseStatus}
                    onChange={(e) => setIncidentResponseStatus(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setIncidentResponseStatus("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        


        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit IncidentResponseStatus" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editIncidentResponseStatus( selectedId, editedIncidentResponseStatus, setEditedIncidentResponseStatus,  setFetcherror, handleAllToasts, setIncidentResponseStatuses);
                if (editedIncidentResponseStatus) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter IncidentResponseStatus Name"
                    value={editedIncidentResponseStatus}
                    onChange={(e) => setEditedIncidentResponseStatus(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setIncidentResponseStatus("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setIncidentResponseStatuses, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default IncidentResponseStatuses
